// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"561":"ab15e202","637":"10d060b1","681":"64bf51d0","787":"07546fca"}[chunkId] + ".chunk.js";
};